import React, {useEffect}from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert"; 

function ConfigureBuildingTable() {
  const navigate = useNavigate();
 
const [buildinglist,setbuildinglist]=React.useState([])

async function buildinglisting() {
  let bodyFormData=''
 
  makeGetRequest('building/getall/'+localStorage.getItem('socityid'), bodyFormData).then((response) => {
      if (response.status === 201) {
          const data =response.data.data;
          console.log(data);
          setbuildinglist(data);

       }else{
        setbuildinglist([])
          swal("There was an error!", response.message, "warning");
      }
}).catch((err) => {
swal("There was an error!", "more error details",  "warning");});
}

useEffect(() => {
  buildinglisting()
},[])
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">Configure Building</h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="residentHeading">Building List</div>
            <div className="addAgencyMain">
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <div className="addSpotsOutBt AssignDutyBt">
                    <Button
                      className="addSpotsBt"
                      onClick={() => navigate("/ConfigureBuilding")}
                    >
                      Add New Building
                    </Button>
                  </div>
                  <div className="confiBuilTablesMain">
                    <Grid container spacing={3}>
                    {buildinglist.map((option) => (

                      <Grid item xs={12} md={6}>
                        <p className="buildHead">Building {option.building_id}</p>


                                      <div>
                                        <TableContainer component={Paper}>
                                          <Table sx={{ width: "100%" }} aria-label="simple table">
                                            {/* <TableHead> */}
                                              <TableRow className="wingsHead1">
                                                <TableCell align="center" colSpan={6}>Building Name:{option.building_name}</TableCell>
                                                


                                              </TableRow>
                                            
                                            <TableBody className="bodyWings">
                                              <TableRow
                                                // key={row.name}
                                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                              >
                                               <TableCell align="center" colSpan={6}>Total Wings:{option.tot_wing}</TableCell>
                                               
                                              </TableRow>
                                              <TableRow
                                                // key={row.name}
                                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                              >
                                                <TableCell align="center" component="th" scope="row">
                                                  Total Floors:-{option.tot_Floor}
                                                </TableCell>
                                               
                                               
                                              </TableRow>
                                              <TableRow
                                                // key={row.name}
                                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                              >
                                                <TableCell align="center" component="th" scope="row">
                                                Total apartments per floor :-{option.tot_Flat_Floor}
                                                </TableCell>
                                               
                                              </TableRow>
                                              <TableRow
                                               
                                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                              >
                                                <TableCell align="center" component="th" scope="row">
                                                Guest parkings per building:-{option.guest_parking_per_build}                                                </TableCell>
                                                
                                              </TableRow>

                                              <TableRow
                                               
                                               sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                             >
                                               <TableCell align="center" component="th" scope="row">
                                               Parking per apartment:-{option.allocated_parking_cnt}                                                </TableCell>
                                               
                                             </TableRow>

                                            </TableBody>
                                          </Table>
                                        </TableContainer>
                                      </div>
                                    

                      </Grid>
                    ))}

                      
                    </Grid>
                  </div>

                  <br />
                  <br />
                  <br />
                  <br />

                  {/* If selected 'NO' option then show this tables */}
                  {/* <div className="confiBuilTablesMain">
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <p className="buildHead">Building One</p>
                        <NoBuildingAddedTable1 />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <p className="buildHead">---</p>
                        <NoBuildingAddedTable2 />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <p className="buildHead">Building Two</p>
                        <NoBuildingAddedTable3 />
                      </Grid>
                    </Grid>
                  </div> */}
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default ConfigureBuildingTable;
